import Router from './util/Router'
import common from './routes/common'
import category from './routes/category'
import home from './routes/home'
import aboutUs from './routes/about'
import forSubs from './routes/for-subs'
import forSchools from './routes/for-schools'
import careers from './routes/careers'
import postTemplateDefault from './routes/post-template-default'
import singleJob from './routes/single-job' //todo: dup?
import singleJobs from './routes/single-job'
import singleGuestAuthors from './routes/single-guest-authors'
import gettingStarted from './routes/getting-started'
import postTemplateSinglePostTemplatePillarPages from './routes/single-pillar-pages'
import pageTemplateTos from './routes/terms'
import pageTemplatePageWhitepaper from './routes/page-whitepaper'

const pageTemplateLegal = pageTemplateTos

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	common,
	home,
	category,
	aboutUs,
	forSubs,
	forSchools,
	careers,
	gettingStarted,
	postTemplateSinglePostTemplatePillarPages,
	pageTemplateLegal,
	pageTemplateTos,
	pageTemplatePageWhitepaper,
	postTemplateDefault,
	singleJob,
	singleJobs,
	singleGuestAuthors
})

/** Load Events */
routes.loadEvents()
